import { defineStore } from 'pinia'

export const BakedData = defineStore('r_bakeddata', {
    state: () => {
        return { r_bakeddata: null }
    },
    actions: {
        get() {
            return this.r_bakeddata
        },
        set(value) {
            this.r_bakeddata = value
        }
    },
})